<template>
  <div class="modal fade" id="app_info_modal" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" style="color: #9b9b9b;" id="exampleModalLongTitle">应用信息</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-loading="loading" element-loading-text="IPA解析">
          <form>
            <div class="form-group row">
              <label style="margin: 1em;" for="colFormLabel" class="col-sm-2 col-form-label">
                <img v-if="pkgInfo.osName=='iOS'&&pkgInfo.bigFile!=true" style="border-radius: 1em;width: 6em;" :src="pkgInfo.iConUrl" />
                <svg v-else class="icon app_logo" style="vertical-align: middle;fill: currentColor;overflow: hidden;"
                  viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11803">
                  <path
                    d="M907.82208 1024H116.1728C64.73728 1024 23.04 982.3232 23.04 930.90816v-535.552C115.61984 492.544 236.84096 562.176 373.19168 590.70976c4.67456 72.89344 64.69632 130.7392 138.80832 130.7392 74.10688 0 134.12864-57.85088 138.8032-130.7392C787.15392 562.176 908.38016 492.544 1000.96 395.35616v535.552C1000.96 982.3232 959.26272 1024 907.82208 1024z m-302.68928-442.18368c0 51.40992-41.69728 93.09184-93.1328 93.09184-51.43552 0-93.13792-41.6768-93.13792-93.09184 0-51.41504 41.69728-93.09184 93.13792-93.09184 51.43552 0 93.1328 41.68192 93.1328 93.09184zM512 442.18368c-72.05888 0-130.67776 54.7328-138.20416 124.75392C235.43808 537.03168 113.40288 463.35488 23.04 360.97024v-35.15392c0-51.40992 41.69728-93.09184 93.1328-93.09184h140.8768C268.83584 102.26688 378.40896 0 512 0c133.59104 0 243.16416 102.26688 254.94528 232.7296h140.8768c51.43552 0 93.13792 41.6768 93.13792 93.09184v35.1488c-90.36288 102.38976-212.39808 176.06144-350.76096 205.96736-7.5264-70.02112-66.14528-124.75392-138.19904-124.75392z m0-349.09184c-82.08896 0-149.8112 60.71808-161.13664 139.63776h322.26816C661.8112 153.80992 594.08896 93.09184 512 93.09184z"
                    fill="#EA743B" p-id="11804"></path>
                </svg>
              </label>
              <div v-if="pkgInfo.osName=='iOS'&&pkgInfo.bigFile!=true" class="col-sm-6" style="padding: 2em 0 0 2em">
                <div class="form-group" style="text-align: left;">
                  <label for="exampleInputEmail1">{{pkgInfo.appVersion}} &nbsp;&nbsp;&nbsp;企业版</label>
                  <input type="text" class="form-control" v-model="pkgInfo.appName" />
                </div>
              </div>
              <div v-else-if="pkgInfo.bigFile==true" class="col-sm-6" style="padding: 2em 0 0 2em">
                <div class="form-group" style="text-align: left;">
                  超大文件上传后展示应用信息
                </div>
              </div>
              <div v-else class="col-sm-6" style="padding: 2em 0 0 2em">
                <div class="form-group" style="text-align: left;">
                  安卓版上传后展示应用信息
                </div>
              </div>

            </div>
            <div class="form-group row" style="padding:0">
              <!-- <label for="colFormLabel" class="col-sm-4 col-form-label">是否启用超级签名</label>
							<div class="col-sm-8">
								
							</div> -->
              <!-- <el-form v-if="packageInfo.osName=='iOS'" ref="form" label-width="8em">
                <el-form-item label="启用超级签名">
                  <el-switch style="margin-left:2em" v-model="useSuperSign"></el-switch>
                </el-form-item>
              </el-form> -->
            </div>
            <div class="form-group row">
              <label for="colFormLabel" class="col-sm-2 col-form-label">描述：</label>
              <div class="col-sm-10">
                <textarea class="form-control" v-model="updateLog" rows="5"></textarea>
              </div>
            </div>
            <div v-if="startUpload" class="progress">
              <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuemin="0"
                aria-valuemax="100" :style="'width:'+progress">{{progress}}</div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <button @click="pkg_upload" :disabled="startUpload" style="width: 30em;height: 3em;" type="button"
            class="btn btn-primary">立即上传</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var self;
export default {
  props: ["pkgFile", "useSuperSign"],
  mounted() {
    self = this;
    console.log(this.useSuperSign);
    this.readPkgInfo(this.pkgFile, function(pkgInfo) {
      self.pkgInfo = pkgInfo;
      self.loading = false;
      self.startUpload = false
      if(pkgInfo.osName=="Android"){
        self.useSuperSign=false
      }
    });
    this.$nextTick(() => {
      $("#app_info_modal").modal("show");
      $("#app_info_modal").on("hidden.bs.modal", function(e) {
        console.log("模态框消失");
        self.$emit("showModal", false);
      });
    });
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      updateLog: "",
      pkgType: 2, //默认企业版
      progress: 0,
      startUpload: true,
      loading: true,
      pkgInfo: {}
    };
  },
  methods: {
    pkg_upload: function() {
      var url = "";
      if (this.pkgInfo.osName == "iOS") {
        url =
          this._Global.FILE_SERVER +
          "/auth/pkg/parse/iOS?authToken=" +
          this.getToken() +
          "&updateLog=" +
          this.updateLog +
          "&iconId=" +
          this.pkgInfo.iConId +
          "&pkgType=2&useSuperSign=" +
          this.useSuperSign;
      }
      if (this.pkgInfo.osName == "Android") {
        url =
          this._Global.FILE_SERVER +
          "/auth/pkg/parse/Android?iconId=0&authToken=" +
          this.getToken() +
          "&updateLog=" +
          this.updateLog +
          "&pkgType=2";
      }
      var formData = new FormData();
      formData.append("file", this.pkgFile);
      let requestConfig = {
        progress: progressEvent => {
          var complete =
            (((progressEvent.loaded / progressEvent.total) * 100) | 0) + "%";
          this.progress = complete;
          if (complete == "100%") {
            self.successToastr("文件上传成功，系统处理完成后自动关闭");
          }
        },
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.startUpload = true;
      this.progress = 0;
      this.$http.post(url, formData, requestConfig).then(response => {
        this.respDataHandle(response.body, data => {
          $("#app_info_modal").modal("hide");
          this.$emit("showModal", false);
          window.location.reload();
        });
      });
    }
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/UploadWindow.vue